<template>
  <div
    class="flex gap-4 w-full items-center rounded-2xl text-right shadow-dropdown-light px-4 py-2 whitespace-pre-line"
    :class="border"
    :style="{ background }">
    <span class="text-xs max-h-lg:!text-base font-simplerBold" :class="color">
      {{ text }}
    </span>
  </div>
</template>

<script lang="ts" setup>
interface IProps {
  color?: string;
  background?: string;
  text: string;
  border?: string;
}

withDefaults(defineProps<IProps>(), {
  text: '',
  background: '#EDD6FF',
  color: 'text-dark',
  border: '',
});
</script>
